<template>
  <div>

    <!-- === Data table === -->
      <v-card>
        <v-card-title>
          <v-btn v-if="! isOperator" rounded class="mr-5" depressed color="primary" @click="handleAdd()">
            <v-icon class="mr-1" dark>
              mdi-plus-circle
            </v-icon>
            {{ $t("addNew") }}
          </v-btn>

          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="productRegistration"
          :search="search"
          hide-default-footer
          class="elevation-1"
          :server-items-length="totalPage"
          :items-per-page="itemsPerPage"
          :page.sync="currentPage"
          :options.sync="options"
          :mobile-breakpoint="0"
        >
          <!-- Progressive -->
          <template v-slot:progress><v-progress-circular indeterminate color="green" :value="50"></v-progress-circular></template>

          <!-- Header -->
          <template v-slot:header.image="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.sku="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.name="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.created_by="{ header }">{{ isOperator ? $t(header.text) : ''}}</template>
          <template v-slot:header.product_type="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.category_name="{ header }">{{ header.text}}</template>
          <template v-slot:header.unit="{ header }">{{ header.text }}</template>
          <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

          <!-- Body -->
          <template v-slot:item.created_by="{ item }">{{isOperator ? item.created_by : ''}}</template>
          <template v-slot:item.image="{ item }"><v-avatar tile size="45"><img :src="item.image.length ? item.image[0].url : ''" alt=""></v-avatar></template>
          <template v-slot:item.action="{ item }">
            <v-btn v-if="! isOperator" color="primary" outlined class="table-action-button mr-2" text icon @click="handleEdit(item, $event)">
              <font-awesome-icon icon="edit"/>
            </v-btn>
            <!-- <v-btn color="error" outlined class="table-action-button" text icon
                  @click.native="handleRemove(item)">
              <font-awesome-icon icon="trash"/>
            </v-btn> -->
          </template>
        </v-data-table>

        <!-- Pagination -->
        <div class="text-center pt-2">
          <v-card-actions>
            <v-col v-if="!$vuetify.breakpoint.xsOnly" class="d-flex" cols="12" sm="1">{{ $t("total") }} : {{ totalPage }}</v-col>
            <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly"><v-select :label="$t('perPage')" v-model="itemsPerPage" :items="pageList"></v-select></v-col>
            <v-pagination
              v-model="currentPage"
              :length="pageCount"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
            ></v-pagination>
            <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
              <v-text-field
                v-model="currentPageComputed"
                :max="pageCount"
                min="1"
                type="number"
                :label="$t('goto')"
              ></v-text-field>
            </v-col>
          </v-card-actions>
        </div>
      </v-card>
    <!-- === End Data table === -->
    
      <v-dialog v-model="$store.state.outsideBusiness.dialog" persistent max-width="600px"  :fullscreen="$store.state.outsideBusiness.dialog_type !== 'image'">
        <product v-if="$store.state.outsideBusiness.dialog_type === 'product'"></product>
        <category v-if="$store.state.outsideBusiness.dialog_type === 'category'"></category>
        <unit v-if="$store.state.outsideBusiness.dialog_type === 'unit'"></unit>
        <image-upload v-if="$store.state.outsideBusiness.dialog_type === 'image'"></image-upload>
      </v-dialog>

  </div>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import mainMixin from "@/mixins/mainMixin";
import optionDataMixin from "@/mixins/optionDataMixin";
import axios from "axios";
import { provider } from "../../../service/provider";
import _ from "lodash";
import product from './product';
import category from './category';
import unit from './unit';
import imageUpload from './imageUpload';

export default {
  name: "stockRegistration",
  mixins: [validatorMixin, mainMixin, optionDataMixin],
  components:{product, category, unit, imageUpload},
  data() {
    return {
      headers: [
        {
          text: "image",
          value: "image",
          sortable: false,
          align: "center",
        },
        { 
          text: "code",
          value: "sku",
          sortable: true,
          align: "center", 
        },
        { 
          text: "shopOwner", 
          value: "created_by",
          sortable: true,
          align: "left", 
        },
        { 
          text: "productName", 
          value: "name",
          sortable: true,
          align: "left", 
        },
        { 
          text: "type", 
          value: "product_type",
          sortable: true,
          align: "center", 
        },
        { 
          text: this.$t('categoryName'), 
          value: "category_name",
          sortable: true,
          align: "center", 
        },
        { 
          text: this.$t("unit"), 
          value: "unit_name",
          sortable: true,
          align: "center", 
        },
        { text: "action", value: "action", sortable: false, width: 115 }
      ],
    };
  },
  methods: {

    async handleAdd() {
      let vm        = this;
      vm.toggleAdd  = true;
      await vm.$store.dispatch('updateOutsideBusinessDialog', {dialog: true, dialog_type: 'product'});
      vm.$store.dispatch('updateOutsideBusinessProduct', {});
    },

    handleRemove(item) {
      let vm = this;
      vm.$confirm(vm.$t("thisWillDelete") + item.id + ' . ' + vm.$t('continue') + '?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        vm.removeTransaction(item.id);
      }).catch(() => {
        vm.$message({
          type: 'info',
          message: vm.$t('deleteCancel')
        });
      });
    },

    removeTransaction(id) {
      let vm = this;
      let url = provider.baseURL + provider.destroyProduct;
      return new Promise((resolve, reject) => {
        axios.post(url, {id: id}, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data.data);
                vm.$message({
                  type: 'success',
                  message: vm.$t('deleteComplete')
                });
                vm.fetchDataTable();
              }
            },
            error => {
              reject(error);
            }
        );
      });
    },

    async handleEdit(item, event) {
      event.preventDefault();
      let vm        = this;
      vm.overlay    = true;
      vm.toggleAdd  = false;

      await vm.$store.dispatch('updateOutsideBusinessDialog', {dialog: true, dialog_type: 'product'});
      vm.$store.dispatch('updateOutsideBusinessProduct', item);
    },

    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.fetchProductRegistration({
        id: '',
        contact_id: this.isOperator ? '' : this.$store.state.userDoc.contact_id,
        search: vm.search,
        offset: vm.currentPage,
        limit: vm.itemsPerPage,
        sortBy: vm.options.sortBy[0] || "created_at",
        sortDesc: vm.options.sortDesc[0]===false ? 0 :1
      });
    }, 700),

  },
  created() {
    if(! this.$store.state.outsideBusiness.dialog){
      this.loading = true;
      this.fetchDataTable();
    }
  },
  computed:{
    detectDialog(){
      return this.$store.state.outsideBusiness.dialog;
    },
  },
  watch: {
    detectDialog(val){ // form product close must refetch api
     if(! val){
        this.loading = true;
       this.fetchDataTable();
     }
    },
    search() {
      this.fetchDataTable();
    },
    currentPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    itemsPerPage() {
      this.loading = true;
      this.fetchDataTable();
    },
  }
  
};
</script>